import React, {
    useState,
    useContext
  } from "react";
  import {
    withRouter
  } from "react-router";
  import {
    makeStyles
  } from "@material-ui/core/styles";
  import TextField from "@material-ui/core/TextField";
  import Select from '@material-ui/core/Select';
  import InputLabel from '@material-ui/core/InputLabel';
  import MenuItem from '@material-ui/core/MenuItem';
  import Grid from "@material-ui/core/Grid";
  import Paper from "@material-ui/core/Paper";
  import Typography from "@material-ui/core/Typography";
  import Button from "@material-ui/core/Button";
  import InputAdornment from "@material-ui/core/InputAdornment";
  import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
  import CircularProgress from "@material-ui/core/CircularProgress";
  import AlertMui from "../core/AlertMui";
  import ModalMui from "../core/ModalMui";
  import TermsOfUseMui from "../core/TermsOfUseMui";
  
  import AlertContext from "../../context/alert/alertContext";
  import ModalContext from "../../context/modal/modalContext";
  import PortalContext from "../../context/portal/portalContext";
  import AuthContext from "../../context/authentication/authContext";
  import useMediaQuery from "../../hooks/useMediaQuery";
  
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "553px",
    },
    paper: {
      padding: theme.spacing(2),
      color: theme.palette.text.secondary,
      marginTop: "20px",
      marginLeft: "20px",
    },
    typography: {
      padding: theme.spacing(3),
      fontSize: "22px",
    },
    form: {
      marginTop: theme.spacing(1),
    },
    contentSubmit: {
      margin: theme.spacing(3, 0, 2),
      textAlign: "center",
    },
  }));
  
  const ChangePasswordPos = (props) => {
    const alertContext = useContext(AlertContext);
    const {
      alert,
      showAlert /* message */
    } = alertContext;
    const authContext = useContext(AuthContext);
    const { user, closeSession, hasToChange } = authContext;
    const portalContext = useContext(PortalContext);
    const { data, terminals } = portalContext;
    const modalContext = useContext(ModalContext);
    const { modalShow, showModal, closeModal } = modalContext;
    const [modalContent, setModalContent] = useState(null);
    const [modalTitle, setModalTitle] = useState("");
    /* useEffect(() => {
       if (message) {
        showAlert(message.msg, message.category);
      }
    }, [message]) */
    let selectedTerminal = ''
    const {
      changePasswordPos
    } = authContext;
    const [changePasswordForm, setChangePasswordForm] = useState({
      newPassword: "",
      repeatPassword: "",
      terminal: ""
    });
  
    const [loading, setLoading] = useState(false);

    const {
      newPassword,
      repeatPassword,
      terminal
    } = changePasswordForm;
  
    const classes = useStyles();
    const isMobile = useMediaQuery("max-width", 600);
  
    //console.log(window.location.href);
    const startIndex = window.location.href.indexOf('?');
    if (startIndex > 0) {
      const hasToShowTermsOfUse = window.location.href.substring(startIndex + '?show-terms-use='.length);
      if (hasToShowTermsOfUse === '1') {
        if (modalTitle !== "Términos de Uso") {
          setModalTitle("Términos de Uso");
          setModalContent(
            <TermsOfUseMui closeModal={closeModal} hasToAccept={true}></TermsOfUseMui>
          );
          showModal();
        }
  
      }
    }
  
  
    const onChange = (e) => {
      setChangePasswordForm({
        ...changePasswordForm,
        [e.target.name]: e.target.value,
      });
    };
  
    const handleChange = (event) => {
        //console.log(event.target.value);
        setChangePasswordForm({
            ...changePasswordForm,
            terminal: event.target.value,
          });
      };
    
    const onSubmit = async (e) => {
      setLoading(true);
      e.preventDefault();
  
      try {
        const response = await changePasswordPos({
          terminalId: terminal,
          customerRut: data.taxPayerInfo.rut,          
        });
  
        if (response.responseCode === 0) {
          showAlert("La contraseña del POS se blanqueó correctamente.", "success");
          
        } else {
          showAlert(response.responseMessage, "error");
        }
      } catch (error) {
        //console.log(error);
        showAlert("Ha ocurrido un error inesperado", "error");
      }
  
      setLoading(false);
    };
  
    return (
      <div className={classes.root}>
        <ModalMui
          modalShow={modalShow}
          showModal={showModal}
          closeModal={closeModal}
          modalTitle={modalTitle}
        >
          {modalContent}
        </ModalMui>
        <Grid item xs={12}>
          <Grid item xs={12} >
            <Typography className={classes.typography}> Blanquear Contraseña POS</Typography>
            <Paper className={classes.paper} >
              <form className={
                classes.form
              }
                style={{
                  width: !isMobile ? "30%" : "100%"
                }
                }
                noValidate onSubmit={
                  onSubmit
                } >
                <InputLabel htmlFor="selectTerminalLabel" id="selectTerminalLabel">Seleccione POS</InputLabel>
                <Select
                margin="normal"
                labelId="selectTerminalLabel"
                id="selectedTerminal"
                style={
                    {
                      fontSize: "14px",
                      width: "28vw"
                    }
                  } 
                  inputProps={{
                    name: 'selectedTerminal',
                    id: 'selectTerminalLabel',
                  }}                 
                value={terminal}
                onChange={handleChange}
                >
                    {terminals.map((terminal, i) => {     
                                
                    // Return the element. Also pass key     
                    return (<MenuItem value={terminal}>{terminal}</MenuItem>) 
                    })}
              
                </Select>
                {
                  alert && < AlertMui message={
                    alert.msg
                  }
                    type={
                      alert.category
                    }
                  />} <Grid className={
                    classes.contentSubmit
                  } > {
                    loading ? (<
                      CircularProgress />
                    ) : (<Button type="submit"
                      variant="contained"
                      color="primary"
                      className={
                        classes.submit
                      } >
                      BLANQUEAR CONTRASEÑA POS </Button>
                      )
                  } </Grid>
              </form >
            </Paper>
          </Grid >
        </Grid>
      </div>
    );
  };
  
  export default withRouter(ChangePasswordPos);